import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const dpinia = createPinia()
dpinia.use(piniaPluginPersistedstate)

export default dpinia
